import { mtBank } from "@assets/images";
import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 80;
const HEIGHT = 40;

export const MntLogo = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <img
      src={mtBank}
      alt=""
      className={className}
      style={{ ...size, objectFit: "contain", ...style }}
    />
  );
};
